
export default {
  inheritAttrs: false,

  props: {
    type: {
      default: 'text',
      type: String,
      required: false
    },

    label: {
      type: String,
      required: false,
      default: ''
    },
    /**
     * @values icons
     */
    icon: {
      /** @type {AlturaIcons} */
      type: String,
      required: false,
      default: ''
    },

    iconAlign: {
      type: String,
      default: 'start',
      validator: value =>
        ['start', 'end'].includes(value)
    },

    addonAlign: {
      type: String,
      default: 'end',
      validator: value => ['start', 'end'].includes(value)
    },

    value: {
      default: undefined,
      type: null,
      required: false
    },

    helpText: {
      default: '',
      type: String,
      required: false
    },

    errorMessage: {
      default: '',
      type: String,
      required: false
    },

    selectAll: {
      default: false,
      type: Boolean,
      required: false
    },

    disabled: {
      type: Boolean
    },

    autofocus: {
      type: Boolean
    },

    /**
     * Don't show errormessages
     */
    noErrorMessage: {
      type: Boolean
    }
  },

  data () {
    return {
      showPassword: false,
      isInvalid: !!this.errorMessage
    };
  },

  computed: {
    currentType () {
      if (this.type === 'password') {
        return this.showPassword ? 'text' : 'password';
      }

      return this.type;
    },
    listeners () {
      return {
        ...this.$listeners,
        input: $event => this.$emit('input', $event.target.value),
        click: $event => this.$emit('click', $event),
        invalid: () => {
          this.$emit('invalid');
          this.isInvalid = true;
        }
      };
    },

    invalid: {
      set (value) {
        this.$el.querySelector('input').setCustomValidity(value ?? '');
      },

      get () {
        return this.$el.querySelector('input').validationMessage;
      }
    }
  },

  watch: {
    value () {
      this.isInvalid = false;
    },

    errorMessage () {
      this.isInvalid = !!this.errorMessage.trim();
    }
  },

  mounted () {
    if (this.autofocus) { this.focus(); }
  },

  methods: {
    focus () {
      if (this.$refs.input) {
        this.$refs.input.focus();
        return;
      }

      this.$el.querySelector('input').focus();
    },

    validate () {
      if (this.$refs.input) {
        return this.$refs.input.checkValidity();
      }

      return this.$el.querySelector('input').checkValidity();
    },

    blur () {
      if (this.$refs.input) {
        this.$refs.input.blur();
        return;
      }

      this.$el.querySelector('input').blur();
    },

    select () {
      this.$refs.input.select();
    },

    togglePassword () {
      this.showPassword = !this.showPassword;
    }
  }
};
